import clsx from 'clsx'
import useSWR from 'swr'

import { ThemesCollectionsDocument } from '@/generated/contentful'

import { client } from '@/lib/contentful/client'
import { serializeCacheKey } from '@/lib/contentful/utils'

import { ThemesIndustryLink } from '../ThemesIndustryLink'

type Props = {
	className?: string
}

export const ThemesIndustriesList = ({ className }: Props) => {
	const { data: industries } = useSWR(
		serializeCacheKey('themesIndustries', { ThemesIndustriesList }),
		() =>
			client().request(ThemesCollectionsDocument, {
				where: {
					type: 'industry'
				}
			})
	)

	return (
		<section className={clsx('w-full', className)}>
			<div>
				<h1 className="text-bc-black pb-4 text-2xl lg:text-xl font-bold">More Categories</h1>

				{/* Categories */}
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
					{industries?.themePropertyCollection?.items.map((industry) => (
						<ThemesIndustryLink key={industry?.slug} industry={industry} />
					))}
				</div>
			</div>
		</section>
	)
}
